import React, { useEffect, useState } from "react";
import { useEspelhoVendas } from "services/api/AppWeb_EspelhoVendas";
import * as Styles from "./styles";
import Header from "./Header";
import Footer from "./Footer";

interface Props {
  onClose: () => void;
  handleVincular: () => void;
  isLoading: boolean;
}

const VincularFichaModal: React.FC<Props> = (props) => {
  return (
    <Styles.Container>
      <Header onClose={() => props?.onClose()} />
      <Footer
        onClose={() => props?.onClose()}
        handleVincular={props?.handleVincular}
        isLoading={props?.isLoading}
      />
    </Styles.Container>
  );
};

export default VincularFichaModal;
